import { Form, Formik } from "formik";
import Callout from "../UI/Callout";
import { useState } from "react";
import { handleAPIError } from "../../utils/index.jsx";
import { stringMax } from "../../models/utils";
import TextInput from "../UI/TextInput";
import PasswordInput from "../UI/PasswordInput";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { object, string } from "yup";
import useProfileBailleurs from "../../hooks/use-profile-bailleurs";
import styles from "./DeleteAccountForm.module.css";

export default function DeleteAccountForm({ onSubmit, isLoading }) {
  const [error, setError] = useState();
  const { profileBailleurs } = useProfileBailleurs();

  async function submitHandler(values) {
    setError("");
    try {
      await onSubmit(values);
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  return (
    <Formik
      initialValues={{ delete: "", password: "" }}
      enableReinitialize={true}
      validationSchema={object({
        delete: stringMax(250)
          .required(" ")
          .matches(/^.*SUPPRIMER.*$/, 'Le champ doit contenir "SUPPRIMER"'),
        password: string().required("Mot de passe requis"),
      })}
      onSubmit={submitHandler}
    >
      <Form className={styles.form}>
        {profileBailleurs.length > 0 && (
          <>
            <p className={"primaryText"}>
              Attention, cette action est irréversible
            </p>
            <p className={"primaryText"}>
              Vous allez supprimer tous les biens / locataires / configurations
              rattachés à ces profils bailleurs :
            </p>
          </>
        )}
        {profileBailleurs.map((profile) => (
          <p> - {profile.nom_profile}</p>
        ))}
        <TextInput
          name={"delete"}
          label={"Veuillez écrire SUPPRIMER en majuscule"}
          marginForm=""
        />
        <PasswordInput
          name={"password"}
          label={"Confirmez le mot de passe de votre compte"}
          marginForm=""
        />
        <div className={"text-right"}>
          <FormikSubmitButton disable={isLoading}>Valider</FormikSubmitButton>
        </div>
        <Callout variant="danger">{error}</Callout>
      </Form>
    </Formik>
  );
}
